<template>
<BootstrapDialog title="试卷属性" ref="dialog" size="lg" @afterClose="afterClose()">
	<template v-slot:body>
		<div style="width: 100%;padding:10px">
		    <table width="100%" border="0" class="table xunw_table_form">
		        <tbody>
		        <tr>
		            <th width="10%" nowrap="nowrap">试卷名称：</th>
		            <td width="40%" v-html="model.sjmc"></td>
		        <!--    <th width="10%" nowrap="nowrap">学员单位：</th>
		            <td v-html="model.jgmc"></td>-->
		        </tr>
		        <tr>
		            <th width="10%" nowrap="nowrap">报考专业：</th>
		            <td width="40%" v-html="model.pcmc"></td>
		            <th width="10%" nowrap="nowrap">课程名称：</th>
		            <td v-html="model.kcmc"></td>
		        </tr>
		        <tr>
		            <th width="10%" nowrap="nowrap">试卷分类：</th>
		            <td width="40%" v-html="model.sjfl=='ZHCY'?'综合测验':'平时作业'"></td>
		            <th width="10%" nowrap="nowrap">试卷状态：</th>
		            <td v-html="model.sjzt== 'ZCKY' ? '正常可用' : '不可用'"></td>
		        </tr>
		        <tr>
		            <th width="10%" nowrap="nowrap">开考时间：</th>
		            <td width="40%" v-html="model.kksj"></td>
		            <th width="10%" nowrap="nowrap">结束时间：</th>
		            <td v-html="model.jssj"></td>
		        </tr>
		        <tr>
		            <th width="10%" nowrap="nowrap">显示形式：</th>
		            <td width="40%" v-html="model.sjxslx=='ZJZS'?'整卷展示':'单题展示'"></td>
		            <th width="10%" nowrap="nowrap">试卷类型：</th>
		            <td>{{ model.sjlx | getSjlx}}</td>
		        </tr>
		        <tr>
		            <th width="10%" nowrap="nowrap">试题排列顺序：</th>
		            <td width="40%" v-html="model.stplsx=='ZC'?'正常':'随机'"></td>
		            <th width="10%" nowrap="nowrap">试卷说明：</th>
		            <td v-html="model.sjsm"></td>
		        </tr>
		        <tr>
		            <th width="10%" nowrap="nowrap">是否显示答案：</th>
		            <td width="40%" v-html="model.sfxsda=='1'?'是':'否'"></td>
		            <th width="10%" nowrap="nowrap">考试验证码：</th>
		            <td width="40%" v-html="model.ksyzm"></td>
		        </tr>
		        <tr>
		            <th width="10%" nowrap="nowrap">是否开启摄像：</th>
		            <td width="40%" v-html="model.sfkqsxt=='1'?'是':'否'"></td>
		            <th width="10%" nowrap="nowrap">抓拍间隔时间：</th>
		            <td width="40%" v-html="model.zpjgsj"></td>
		        </tr>
		        <tr>
		            <th width="10%" nowrap="nowrap">阅卷讲师：</th>
		            <td width="90%" v-html="model.jsxms" colspan="3"></td>
		        </tr>
		        </tbody>
		    </table>
		</div>
	</template>
	<template v-slot:footer>
			<button class="btn btn-default" type="button" @click="close()">关闭</button>
	</template>
</BootstrapDialog>
</template>
<script>
    /**
     * 试卷管理 综合测验 试卷属性（查看）
     */
    export default {
        name: "ExamPapershuxing",
        data: function () {
            return {
                model: {
                    sjmc: '',	     //试卷名称
                    jgdm: '',	     //机构代码    不需拼接
                    jgmc: '',	     //机构名称 学员单位
                    pcmc: '',	     //培训项目
                    kcdm: '',	     //课程代码      不需拼接
                    kcmc: '',	     //课程名称
                    sjfl: '',	     //试卷分类
                    sjzt: '',	     //试卷状态
                    kksj: '',	     //开考时间
                    jssj: '',	     //结束时间
                    sjxslx: '',	     //试卷显示类型
                    sfxsda: '',	     //是否显示答案
                    sjlx: '',	    //试卷类型
                    stplsx: '',   //试题排列顺序
                    sjsm: '',	//试卷说明
                    sfkqsxt: '', //摄像头
                    zpjgsj: '', //抓拍时间
                    ksyzm: '', //验证码
                    jsxms:''	//讲师姓名
                }
            }
        },
		filters: {
			getSjlx (value) {
				if (value == 'PT') {
					return '普通'
				} else if(value == 'SJ') {
					return '随机'
				} else if (value == 'MB'){
					return '试卷模板'
				}
			}
		},

        methods: {
			reset:function(){
				this.model = {
				    sjmc: '',	     //试卷名称
				    jgdm: '',	     //机构代码    不需拼接
				    jgmc: '',	     //机构名称 学员单位
				    pcmc: '',	     //培训项目
				    kcdm: '',	     //课程代码      不需拼接
				    kcmc: '',	     //课程名称
				    sjfl: '',	     //试卷分类
				    sjzt: '',	     //试卷状态
				    kksj: '',	     //开考时间
				    jssj: '',	     //结束时间
				    sjxslx: '',	     //试卷显示类型
				    sfxsda: '',	     //是否显示答案
				    sjlx: '',	    //试卷类型
				    stplsx: '',   //试题排列顺序
				    sjsm: '',	//试卷说明
				    sfkqsxt: '', //摄像头
				    zpjgsj: '', //抓拍时间
				    ksyzm: '', //验证码
				    jsxms:''	//讲师姓名
				}
			},
			async open(params){
				let id = params.id;
				let res =await this.$http.post('/htgl/biz/zypx/sj/zhcy/ck', {id: id});
				if(res.data){
					 this.model = res.data;
				}
				this.$refs.dialog.open();
			},
			close:function(){
				this.$refs.dialog.close();
			},
			afterClose:function(){
				this.$validator.reset();
				this.reset();
			}
        }

    }
</script>
<style scoped>
    .tm_main {
        margin: 10px 10px;
        width: 100%;
    }

    .tm_table_form tbody p {
        margin: 10px 10px;
    }

    .tm_table_form tbody tr th {
        text-align: right;
        font-size: 16px;
        border: solid 1px #eee;
        background: #f5f5f5;
        line-height: 20px;
        font-weight: 800;
        padding: 12px;
    }

    .tm_table_form tr td {
        border: solid 1px #eee;
        padding: 12px;
        text-align: left;
        border: solid 1px #eee !important;
        background: #fff !important;
    }

    #tm_title div span {
        border: solid 1px green;
        padding: 5px;
    }
</style>
